var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "card",
      staticClass: "global-search-results-card card mx-0 p-0",
      class: { "po-match-card": _vm.isPoMatch, dark: _vm.$theme.isDark },
    },
    [
      _c("div", { staticClass: "s-result" }, [
        _c("div", { staticClass: "s-car image-container" }, [
          _vm.isImageLoading
            ? _c("div", { staticClass: "image-loading-spinner" }, [
                _c("div", { staticClass: "spinner" }),
              ])
            : !_vm.isVisible
            ? _c("div", { staticClass: "image-lazy-placeholder" }, [
                _c(
                  "span",
                  { staticClass: "material-symbols-outlined lazy-icon" },
                  [_vm._v("directions_car")]
                ),
              ])
            : _c("img", {
                staticClass: "quote-image",
                class: { "no-image": !_vm.imageUrl || _vm.isPlaceholder },
                style: { opacity: _vm.isImageLoading ? 0 : 1 },
                attrs: {
                  src:
                    _vm.imageUrl ||
                    require("@/assets/images/placeholderGlobalSearch.svg"),
                },
                on: { error: _vm.handleImageError },
              }),
          _c("span", {
            staticClass: "s-car-reg",
            domProps: {
              innerHTML: _vm._s(_vm.getHighlightedText("regoNo", _vm.rego)),
            },
          }),
        ]),
        _c(
          "div",
          { staticClass: "s-info" },
          [
            _c("div", { staticClass: "s-top" }, [
              _c("span", { staticClass: "s-quote" }, [
                _c("span", { staticClass: "s-quote-prefix" }, [
                  _vm._v(_vm._s(_vm.displayReferencePrefix)),
                ]),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.displayReferenceNumber) },
                }),
              ]),
              !_vm.isInvoiceResult && !_vm.isPoResult
                ? _c(
                    "span",
                    { staticClass: "s-status", class: _vm.jobStatusClass },
                    [_vm._v(_vm._s(_vm.jobStatusText))]
                  )
                : _vm._e(),
            ]),
            _c("div", {
              staticClass: "s-name has-tooltip-arrow",
              attrs: {
                "data-tooltip": _vm.buildYear
                  ? `${_vm.buildYear} ${_vm.makeModel}`
                  : _vm.makeModel,
              },
              domProps: {
                innerHTML: _vm._s(
                  (_vm.buildYear
                    ? _vm.getHighlightedText("buildYear", _vm.buildYear) + " "
                    : "") + _vm.getHighlightedText("makeModel", _vm.makeModel)
                ),
              },
            }),
            !_vm.isPoResult && !_vm.isInvoiceResult
              ? _c("div", { staticClass: "s-sub s-sub-customer-row" }, [
                  _c("span", { staticClass: "s-sub-item" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Customer:")]),
                    _c("span", {
                      staticClass: "s-val s-val-customer",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getHighlightedText(
                            "customer",
                            _vm.customerName || "-"
                          )
                        ),
                      },
                    }),
                  ]),
                  _vm.phoneNo
                    ? _c("span", { staticClass: "s-sub-item" }, [
                        _c("span", { staticClass: "s-lbl" }, [_vm._v("Ph:")]),
                        _c("span", {
                          staticClass: "s-val",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getHighlightedText("phoneNo", _vm.phoneNo)
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            !_vm.isPoResult && !_vm.isInvoiceResult
              ? _c("div", { staticClass: "s-sub" }, [
                  _c("span", { staticClass: "s-sub-item" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Colour:")]),
                    _c("span", {
                      staticClass: "s-val",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getHighlightedText("colour", _vm.color || "-")
                        ),
                      },
                    }),
                  ]),
                  _c("span", { staticClass: "s-sub-item" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Claim:")]),
                    _c("span", {
                      staticClass: "s-val",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getHighlightedText("claimNo", _vm.claimNo || "-")
                        ),
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            !_vm.isPoResult && !_vm.isInvoiceResult
              ? _c("div", { staticClass: "s-sub" }, [
                  _c("span", { staticClass: "s-sub-item" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Insurer:")]),
                    _c("span", {
                      staticClass: "s-val",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getHighlightedText("insurer", _vm.insurer || "-")
                        ),
                      },
                    }),
                  ]),
                  _c("span", { staticClass: "s-sub-item" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Assessor:")]),
                    _c("span", {
                      staticClass: "s-val",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getHighlightedText(
                            "assessorName",
                            _vm.assessor || "-"
                          )
                        ),
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm.isInvoiceResult
              ? [
                  _c("div", { staticClass: "s-claim" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Customer:")]),
                    _c("span", {
                      staticClass: "s-val",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getHighlightedText(
                            "customer",
                            _vm.customerName || "-"
                          )
                        ),
                      },
                    }),
                    _c("span", { staticClass: "s-divider" }, [_vm._v("|")]),
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Total:")]),
                    _c("span", { staticClass: "s-val s-val-total" }, [
                      _vm._v(_vm._s(_vm.formattedInvoiceTotal)),
                    ]),
                  ]),
                  _c("div", { staticClass: "s-claim" }, [
                    _c("span", { staticClass: "s-lbl" }, [_vm._v("Date:")]),
                    _c("span", { staticClass: "s-val" }, [
                      _vm._v(_vm._s(_vm.formattedInvoiceDate)),
                    ]),
                  ]),
                ]
              : _vm.isPoResult
              ? _c("div", { staticClass: "s-claim" }, [
                  _c("span", { staticClass: "s-lbl" }, [_vm._v("Supplier:")]),
                  _c("span", {
                    staticClass: "s-val",
                    domProps: { innerHTML: _vm._s(_vm.displaySupplier) },
                  }),
                ])
              : _vm._e(),
            _vm.isPoResult
              ? _c("div", { staticClass: "s-claim" }, [
                  _c("span", { staticClass: "s-lbl" }, [_vm._v("Date:")]),
                  _c("span", { staticClass: "s-val" }, [
                    _vm._v(_vm._s(_vm.primaryPoDate)),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }